import React, { Component } from "react";
import { Router, Route, Switch } from "react-router-dom";
import { createBrowserHistory } from "history";

//import Navbar from "./layout/Navbar";
import LoginForSuperAdmin  from "./auth/LoginForSuperAdmin";
import Landing from "./landing/Home";
import UserList from "./users/UserList";
//modal imports
import ModalManager from "./modals/ModalManager";
import DwarkaDashboard from "./dwk/dashboard/DwarkaDashboard";
import GurgaonDashboard from "./gurgaon/dashboard/GurgaonDashboard";
import {handleSetRemoveAuth} from "./functions/Functions"


//***********************************************************
handleSetRemoveAuth() 
//
const history = createBrowserHistory()

class App extends Component {
  render() {
    return (
      <div>
        <Router history={history}>
          <div> 
            <ModalManager />

            <div>
              {/* <Navbar /> */}
              <Switch>
              
              <Route exact path="/" component={Landing} />
              <Route exact path="/sadmin" component={LoginForSuperAdmin} />
              <Route exact path="/UserList" component={UserList} />
              <Route path="/dwk" component={DwarkaDashboard} />
              <Route path="/ggn" component={GurgaonDashboard} />
              </Switch>
            </div>

          </div>
        </Router>
      </div>
    );
  }
}

export default App;
